import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ObjArrPipe } from "./obj-arr.pipe";
import { KeyValPipe } from "./key-val.pipe";
import { UiNamePipe } from './ui-name.pipe';

@NgModule({
  declarations: [
  	ObjArrPipe,
  	KeyValPipe,
  	UiNamePipe
  ],
  imports: [
    CommonModule
  ],
  exports : [
  	ObjArrPipe,
  	KeyValPipe,
  	UiNamePipe
  ]
})
export class PipesModule { }
